import { render, staticRenderFns } from "./dialogClassification.vue?vue&type=template&id=583c1464&"
import script from "./dialogClassification.vue?vue&type=script&lang=js&"
export * from "./dialogClassification.vue?vue&type=script&lang=js&"
import style0 from "./dialogClassification.vue?vue&type=style&index=0&id=583c1464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports